<div
  class="d-inline-flex image-upload"
  [class.no-image]="!imageUrl"
  [class.read-only-image]="readOnly"
>
  <app-item-image
    *ngIf="imageUrl; else placeholder"
    [imageUrl]="imageUrl"
    [useBackgroundImage]="true"
    [size]="imageSize"
  ></app-item-image>
  <ng-template #placeholder>
    <app-item-image
      [imageUrl]="''"
      [useBackgroundImage]="true"
      [size]="imageSize"
      class="placeholder-image bg-white"
    ></app-item-image>
  </ng-template>
  <div class="opacity-layer"></div>
  <i class="fas fa-cloud-upload-alt image-upload-icon"></i>
  <span class="d-block text-center">{{ uploadText | translate }}</span>
  <app-file-input
    *ngIf="canUpload && !readOnly"
    [overlay]="true"
    [inputId]="inputId"
    name="image"
    [accept]="accept"
    [title]="uploadTitle"
    (fileSelected)="fileSelected.emit($event)"
  ></app-file-input>
  <i
    class="fas fa-times-circle removeIcon"
    *ngIf="canRemove"
    (click)="removeClick.emit()"
  ></i>
</div>
